import { render, staticRenderFns } from "./AddCustomer.vue?vue&type=template&id=480dd384&scoped=true"
import script from "./AddCustomer.vue?vue&type=script&lang=js"
export * from "./AddCustomer.vue?vue&type=script&lang=js"
import style0 from "./AddCustomer.vue?vue&type=style&index=0&id=480dd384&prod&lang=scss&scoped=true"
import style1 from "./AddCustomer.vue?vue&type=style&index=1&id=480dd384&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480dd384",
  null
  
)

export default component.exports